export var ACCORDIAN_CELL_IDS = {
  REBATE: 'rebate',
  ACCESSORIES: 'accessories',
  FNI: 'fni',
  FEES: 'fees'
};
export var PAYMENT_TYPE_MAPPER = {
  LOAN: {
    label: __('Loan'),
    value: 'LOAN'
  },
  LEASE: {
    label: __('Lease'),
    value: 'LEASE'
  },
  CASH: {
    label: __('Cash'),
    value: 'CASH'
  },
  ONE_TIME_LEASE: {
    label: __('One Pay'),
    value: 'ONE_TIME_LEASE'
  },
  BALLOON: {
    label: __('Balloon'),
    value: 'BALLOON'
  }
};
export var PAYMENT_MODES = [{
  label: __('Loan'),
  value: 'LOAN'
}, {
  label: __('Lease'),
  value: 'LEASE'
}, {
  label: __('Cash'),
  value: 'CASH'
}, {
  label: __('One Pay'),
  value: 'ONE_TIME_LEASE'
}, {
  label: __('Balloon'),
  value: 'BALLOON'
}];
export var DEAL_TYPES = [{
  value: 'BUSINESS',
  label: __('Business')
}, {
  value: 'PERSONAL',
  label: __('Personal')
}];